<template>
    <div class="page">
        <div class="page_content article-text">
            <div class="article-title">{{text.title[lang]}}</div>
            <!-- <div class="article-subtitle">{{text.subtitle[lang]}}</div> -->
            <!-- <div class="article-logobox">
                <img src="../assets/images/deansel_logo.png" alt="">
                <div>&amp;</div>
                <img src="../assets/images/deansel_logo.png" alt="">
            </div> -->
            <div class="article-from">{{text.from[lang]}}</div>
            <!-- <div class="article-img">
                <img class="img_widthfix" :src="text.img1" alt="">
            </div> -->
            <div class="article-paragraph">{{text.content1[lang]}}</div>
            <div class="article-title2">{{text.title2_1[lang]}}</div>
            <div class="article-paragraph">{{text.content2[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img2" alt="">
            </div>
            <div class="article-title3">{{text.title3_1[lang]}}</div>
            <div class="article-paragraph">{{text.content3[lang]}}</div>
            <div class="article-img-40">
                <img class="img_widthfix" :src="text.img3" alt="">
            </div>
            <div class="article-paragraph">{{text.content4[lang]}}</div>
            <div class="article-title3">{{text.title3_2[lang]}}</div>
            <div class="article-paragraph">{{text.content5[lang]}}</div>
            <div class="article-title2">{{text.title2_2[lang]}}</div>
            <div class="article-paragraph">{{text.content6[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img4" alt="">
            </div>
            <div class="article-paragraph">{{text.content7[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img5" alt="">
            </div>
            <div class="article-paragraph">{{text.content8[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img6" alt="">
            </div>
            <div class="article-paragraph">{{text.content9[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img7" alt="">
            </div>
            <div class="article-title2">{{text.title2_3[lang]}}</div>
            <div class="article-paragraph">{{text.content10[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img8" alt="">
            </div>
            <div class="article-paragraph">{{text.content11[lang]}}</div>
            <div class="article-img">
                <img class="img_widthfix" :src="text.img9" alt="">
            </div>
            <div class="article-paragraph">{{text.content12[lang]}}</div>
        </div>
        <Foot></Foot>
        <Nav navstyle="dark"></Nav>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {wxShare} from '@/js/api.js'
import {articleText1} from '@/js/text.js'
export default {
    data () {
        return {
            text: articleText1
        }
    },
    components: {
        Nav,
        Foot
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '文章1-天猫国际未来防晒指南'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    }
}
</script>

<style scoped>
.article-img-40 {
    width: 40%;
    margin: 5% auto 3% auto;
}
@media screen and (max-width: 756px) {
    .article-img-50 {
        width: 80%;
    }
}
</style>
